module.exports = __webpack_public_path__ + "img/4-1-4-1-preview-e.45f8538c.jpg";